import { useEffect, useState } from "react";

export const DEFAULT_DELAY = 500;

export const useDebounce = (value: string, delay: number = DEFAULT_DELAY) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timerId);
        };

    }, [value, delay]);

    return debouncedValue;
}